import { type RefObject, useCallback, useEffect, useState } from "react";
import ImageLightbox, { type ImageLightboxSlide } from "../text-editor/ImageLightbox";

export default function ChatImageLightbox({ containerRef }: { containerRef: RefObject<HTMLDivElement | null> }) {
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const [lightboxSlides, setLightboxSlides] = useState<ImageLightboxSlide[]>([]);

    const handleImageClick = useCallback((e: MouseEvent) => {
        const target = e.target as HTMLElement;
        const anchor = target.closest(".orsanemedia--image a") as HTMLAnchorElement | null;
        if (!anchor) return;

        e.preventDefault();
        e.stopPropagation();

        const container = containerRef.current;
        if (!container) return;

        const allAnchors = Array.from(container.querySelectorAll(".orsanemedia--image a")) as HTMLAnchorElement[];
        const slides: ImageLightboxSlide[] = allAnchors
            .map((a) => {
                const img = a.querySelector("img") as HTMLImageElement | null;
                return { src: a.href, title: img?.alt || undefined, thumbSrc: img?.currentSrc || img?.src };
            })
            .filter((s) => !s.src.startsWith("blob:"));

        const index = slides.findIndex((s) => s.src === anchor.href);
        setLightboxSlides(slides);
        setLightboxIndex(Math.max(0, index));
        setLightboxOpen(true);
    }, [containerRef]);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;
        container.addEventListener("click", handleImageClick);
        return () => container.removeEventListener("click", handleImageClick);
    }, [containerRef, handleImageClick]);

    return (
        <ImageLightbox
            open={lightboxOpen}
            index={lightboxIndex}
            slides={lightboxSlides}
            onClose={() => setLightboxOpen(false)}
        />
    );
}
